﻿$.fn.dxCtrlContentFormulaireSaisie = function custom_dxCtrlContentFormulaireSaisie(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlformulairesaisie dx-ctrl");
        this.createInstance(new cdxCtrlContentFormulaireSaisie(this, option));
    }
    return this;
}

window.cdxCtrlContentFormulaireSaisie = function (container, option) {
    var Me = this;
    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.inPopup == 'undefined') option.inPopup = true
    if (typeof option.disableSave == 'undefined') option.disableSave = true

    function mConstruit() {
        container.empty()
        if (option.inPopup) {
            var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                fullScreen: true,
                showTitle: false,
                showClose: option.showClose,
                contentTemplate: function (contentElement) {
                    contentElement.css("position", "relative")
                    contentElement.css("padding", "0")
                    mRempli(contentElement)
                }
            }).dxCtrlPopupBase("instance")
            popup.show()
        } else {
            container.css("position", "relative")
            mRempli(container)
        }
    }

    var indexCleNav = null
    var dataJson = null
    var dataFormulaireReponse = null
    function mRempli(contentElement) {
        contentElement.empty()

        if (option.dataFormulaire && option.dataFormulaire.fini == "1") {
            contentElement.css({
                "display": "flex",
                "align-items": "center",
                "justify-content": "center"
            })
            var $Div = $("<div style='text-align:center;'/>").appendTo(contentElement).text("Ce formulaire n'est plus disponible...")
        } else {
            indexCleNav = 'cle_nav_formulaire' + option.dataFormulaire.id_formulaire + '_' + parametre.code_appli
            var $Iframe = $("<iframe style='width:100%;height:100%;border:none;overflow-x:hidden;overflow-y:hidden;white-space;nowrap;'/>").appendTo(contentElement).on("load",
                function () {
                    var src = $Iframe.attr("src")
                    if (!src || src == "about:blank") return
                    if (option.dataFormulaire) {
                        if (!dataFormulaireReponse) {
                            if (option.idFormulaireReponse & option.idFormulaireReponse != "0") {
                                //on a un idFormulairereponse
                                dataFormulaireReponse = option.bddCtrl.getObjet("formulaire_reponse", option.idFormulaireReponse).data
                                if (dataFormulaireReponse) {
                                    dataJson = JSON.parse(dataFormulaireReponse.json)
                                    mContinue()
                                } else {
                                    mInitNewDataFormulaireReponse(function () { mContinue() })
                                }
                            } else {
                                //on regarde si on a une cle_navigateur
                                var cleNav = localStorage.getItem(indexCleNav);
                                if (cleNav) {
                                    option.bddCtrl.mAjaxCall({
                                        command: "getdataformulairereponsewithclenav",
                                        cle_nav:cleNav
                                    }, function (data) {
                                        if (data.id_formulaire_reponse) {
                                            option.idFormulaireReponse = data.id_formulaire_reponse
                                            dataFormulaireReponse = option.bddCtrl.getObjet("formulaire_reponse", option.idFormulaireReponse).data
                                            if (dataFormulaireReponse) {
                                                dataJson = JSON.parse(dataFormulaireReponse.json)
                                                mContinue()
                                            } else {
                                                mInitNewDataFormulaireReponse(function () { mContinue() })
                                            }
                                        } else {
                                            mInitNewDataFormulaireReponse(function () { mContinue() })
                                        }
                                    })
                                } else if (option.dataFormulaire && !option.ignoreSave) {
                                    mInitNewDataFormulaireReponse(function () { mContinue() })
                                }
                            }
                        } else {
                            dataJson = JSON.parse(dataFormulaireReponse.json)
                            mContinue()
                        }
                    } else {
                        dataJson = {}
                        mContinue()
                    }

                    function mContinue() {
                        debugger
                        var clBuilderFormulaire = null
                        if (option.disableSave) {
                            clBuilderFormulaire = new cBuilderFormulaire(option.bddCtrl, $Iframe)
                        } else {
                            clBuilderFormulaire = new cBuilderFormulaire(option.bddCtrl, $Iframe, onValueChangedDevexpress)
                        }
                        clBuilderFormulaire.mInitIframe(function () {
                            if (!option.disableSave) mInitWithJson()
                        })

                        function mInitWithJson() {
                            if (!dataJson) { window.setTimeout(function () { mInitWithJson() }, 50) }
                            else {
                                clBuilderFormulaire.mInitWithData(dataJson)
                                //on finalise si on a des ctrl de saisie
                                if (dataFormulaireReponse) {
                                    if (!clBuilderFormulaire.hasCtrlSaisie()) {
                                        dataFormulaireReponse.finalise = "1"
                                        option.bddCtrl.getObjet(dataFormulaireReponse).mSaveChamp("finalise")
                                    }
                                }
                            }
                        }
                    }

                })

            if (option.urlHtml) {
                //pour la prévisualisation
                $Iframe.attr("src", option.urlHtml)
            } else {
                if (option.dataFormulaire) {
                    option.bddCtrl.mAjaxCall({
                        command: "gethtmlurldataemailbdd",
                        nom_table: "formulaire",
                        id: option.dataFormulaire.id_formulaire
                    }, function (data) {
                        $Iframe.attr("src", data.urlhtml)
                    })
                } else {
                    contentElement.empty()
                    contentElement.css({
                        "display": "flex",
                        "align-items": "center",
                        "justify-content": "center"
                    })
                    var $Div = $("<div style='text-align:center;'/>").appendTo(contentElement).text("Ce formulaire n'est plus disponible...")
                }
            }


            //if (option.dataFormulaire) {
            //    if (!dataFormulaireReponse) {
            //        if (option.idFormulaireReponse) {
            //            dataFormulaireReponse = option.bddCtrl.getObjet("formulaire_reponse", option.idFormulaireReponse).data
            //            if (dataFormulaireReponse) {
            //                dataJson = JSON.parse(dataFormulaireReponse.json)
            //            } else {
            //                mInitNewDataFormulaireReponse()
            //            }
            //        } else if (option.dataFormulaire && !option.ignoreSave) {
            //            mInitNewDataFormulaireReponse()
            //        }
            //    } else {
            //        dataJson = {}
            //    }
            //} else {
            //    dataJson = {}
            //}


        }

    }

    function mInitNewDataFormulaireReponse(funcFin) {
        var cleNav = generateGuid();
        dataFormulaireReponse = option.bddCtrl.getObjet("formulaire_reponse").mGetNewData()
        dataFormulaireReponse.id_formulaire = option.dataFormulaire.id_formulaire
        dataFormulaireReponse.id_table = toPositiveInt(option.id_table)
        dataFormulaireReponse.id = toPositiveInt(option.id)
        dataFormulaireReponse.cle_navigateur = cleNav
        option.bddCtrl.getObjet(dataFormulaireReponse).mSave(function () {
            localStorage.setItem(indexCleNav, cleNav);
            dataJson = JSON.parse(dataFormulaireReponse.json)
            if (funcFin) funcFin()
        })
    }

    function onValueChangedDevexpress(ctrl, lstCtrlDevexpress, index, tri, typeDevexpress, typeCtrlSelectDevexpress, typChamp, titre, value) {
        if (typeDevexpress == "dxButton") {
            //on a cliqué sur un bouton valider
            //value contient le text à afficher
            //on vérifie si les champs obligatoire sont rempli
            var lstOblig = lstCtrlDevexpress.filter(function (dx) {
                return dx.element().hasClass("obligatoire")
            })
            lstOblig.forEach(function (dx) {
                dx.element().css("background-color", "")
                dx.element().closest("td").css("border-left", "")
            })
            var lstObligVide = lstOblig.filter(function (dx) { return dx.isEmpty() })
            if (lstObligVide.length > 0) {
                lstObligVide.forEach(function (dx, idx) {
                    if (idx == 0) dx.focus()
                    dx.element().css("background-color", "rgba(255, 0, 0,0.1)")
                    dx.element().closest("td").css("border-left", "3px solid red")
                })
                mNotify("Veuillez remplir tous les champs obligatoires", "error", 6000)
                return
            }

            if (dataFormulaireReponse) {
                dataFormulaireReponse.finalise = "1"
                option.bddCtrl.getObjet(dataFormulaireReponse).mSaveChamp("finalise", function () {
                })
                $("body").empty()
                $("body").css({
                    "display": "flex",
                    "align-items": "center",
                    "justify-content": "center"
                })
                $("<div/>").appendTo("body").html(value)
            }
        } else {
            ctrl.option("disabled", true)
            if (!dataJson.lst) dataJson.lst = []
            var ele = dataJson.lst.filter(function (o) { return o.index == index })[0]
            if (!ele) {
                ele = { index: index }
                dataJson.lst.push(ele)
            }
            ele.tri = tri
            ele.typeDevexpress = typeDevexpress;
            ele.typeCtrlSelectDevexpress = typeCtrlSelectDevexpress;
            ele.typChamp = typChamp;
            ele.titre = titre;
            ele.value = value
            if (dataFormulaireReponse) {
                dataFormulaireReponse.json = JSON.stringify(dataJson)
                option.bddCtrl.getObjet(dataFormulaireReponse).mSaveChamp("json", function () {
                    ctrl.option("disabled", false)
                })
            } else {
                ctrl.option("disabled", false)
            }
        }

    }

    this.element = function () { return container }

    mConstruit();
}